import React, {Component} from 'react';
import ReactToPrint from 'react-to-print';
import DailySalesReportFilter from '../components/DailySalesReportsFilter';
import DailySalesByDayReport from '../components/DailySalesByDayReport';
import ReportHeaderLocation from '../components/ReportHeaderLocation';
import NoAccess from '../noAccess';
import {getTimeZoneOffsetDefault} from '../shared/dateTimeLists';
import {hasReportsAccess} from '../shared/authFunctions';
import FuseTheme from '../global/theme';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/date-range';

export const fuseDailySalesReportsIcon = Icon;

const styles = {
    avatar: {backgroundColor: "#6e6e6e", width: 40, height: 40, marginRight: 10, verticalAlign: 'bottom'},
    button: {color: FuseTheme.palette.primary3Color},
};

/**
 * Daily Sales Reports class for retrieving and displaying Daily Sales Summary
 *
 */
export class DailySalesReports extends Component {
    constructor(props) {
        super(props);
        const system = localStorage.getItem('system');
        const offsetDefault = getTimeZoneOffsetDefault();
        this.state = {
            errorMessage: null,
            location: {
                id: null,
                name: '',
                city: '',
                state: ''
            },
            selectedDay: null,
            selectedOffset: offsetDefault,
            summaryComplete: false,
            system: system
        };
    }

    /**
     * Handle submission from filter
     *
     * @param location
     * @param day
     * @param offset
     */
    handleFilterSubmit = (location, day, offset) => {
        // Set Location, Day and Offset selection for DailySalesReportSummary component
        this.setState({location: location});
        this.setState({selectedDay: day});
        this.setState({selectedOffset: offset});
    };

    handleFilterClear = () => {
        this.setState({
            errorMessage: null
        });
    };

    /**
     * Handle event props for Daily Sales Summary table completion
     *
     * @param isComplete
     */
    handleSummaryComplete = (isComplete) => {
        this.setState({
            summaryComplete: isComplete,
        });
    };

    handleReportError = (message) => {
        this.setState({
            errorMessage: message,
            summaryComplete: true,
        });
    };

    render() {
        const {
            errorMessage,
            location,
            selectedDay,
            selectedOffset,
            summaryComplete,
            system
        } = this.state;

        if (!hasReportsAccess()) return <NoAccess/>;

        const ListTitle = <span className="list-title hide-print"><Avatar icon={<Icon/>} style={styles.avatar}
                                                                          className="avatar-title"/>Daily Sales Reports</span>;

        const ListDescription = () => {
            return (
                <span className="list-description hide-print">
                    <p>A Daily Report displays sales totals of all payments for a specific Location on a specified
                        date. The Report lists all Sales made on the specified date which includes products purchased
                        and payment types used.</p>
                    <p>Select a Location, Date, and Time Zone Offset to generate a Report:</p>
                </span>
            );
        };

        return (
            <div className="lists-container" ref={e => (this.printReportRef = e)}>
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        {/* Daily Sales Report Filter (Location and Day Picker) */}
                        <DailySalesReportFilter
                            onSubmit={this.handleFilterSubmit}
                            onClear={this.handleFilterClear}
                        />

                        {/* Print Header */}
                        {location && selectedDay &&
                        <ReportHeaderLocation
                            location={location}
                            zeroDay={selectedDay}
                            reportType="Daily Sales Summary"
                        />
                        }

                        {/* Daily Sales Report Content */}
                        {location.id && selectedDay && selectedOffset &&
                        <div>

                            {/* Daily Sales Report Header, Loader, and messaging */}
                            <div className="report-header">
                                <div className="btn-print-container report-header-button-container">
                                    <ReactToPrint
                                        trigger={() =>
                                            <RaisedButton
                                                primary
                                                type="button"
                                                label="Print Report"
                                                style={styles.button}
                                            />
                                        }
                                        content={() => this.printReportRef}
                                    />
                                </div>
                                <h2 className="report-header-title">Daily Sales Report</h2>
                                <p>
                                    <span className="bold">Location </span>
                                    {location.id}<br/>
                                    {location.name}<br/>
                                    {location.city}, {location.state}<br/>
                                </p>
                            </div>
                            {!summaryComplete &&
                            <div className="loader-container">
                                <h4>Generating Report...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                            }

                            {/* Daily Sales by Day Summary */}
                            <DailySalesByDayReport
                                day={selectedDay}
                                locationId={location.id.toString()}
                                offset={selectedOffset}
                                onSummaryComplete={this.handleSummaryComplete}
                                onError={this.handleReportError}
                                system={system}
                            />
                        </div>
                        }

                        {/* Error and Messaging */}
                        {errorMessage &&
                            <div className="error">
                                <p>{errorMessage}</p>
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Report/DailySalesReports.js